import React from "react";
import { ReactComponent as UsdtIconRound } from "images/coins/usdtIconRound.svg";
import { ReactComponent as UsdcIconRound } from "images/coins/usdcIconRound.svg";
import { ReactComponent as EthIconRound } from "images/coins/ethIconRound.svg";
import { ReactComponent as TronIconRound } from "images/coins/tronIconRound.svg";
import { ReactComponent as RubIcon } from "images/coins/rubIcon.svg";
import "../../styles/imageStyles.css";

const ICON_COMPONENTS: Record<string, React.ComponentType<{ className?: string }>> = {
  RUB: RubIcon,
  USDT: UsdtIconRound,
  USDC: UsdcIconRound,
  ETH: EthIconRound,
  TRX: TronIconRound,
};

export const getCryptoIconRound = (
  currency: string,
  size: "sm" | "md" | "lg" | "xl" | "2xl" = "lg"
): React.ReactElement | null => {
  const sizeClass = `icon-${size}`;

  const IconComponent = ICON_COMPONENTS[currency.toUpperCase()];

  if (!IconComponent) return null;

  return <IconComponent className={sizeClass} />;
};
